<template>
  <div class="media">
    <div style="max-width: 200px" class="mr-3">
      <field :field="fields.get('image_id')" :model="model" :errors="errors" />
    </div>
    <div class="media-body">
      <fields
        :fields="fields.except('image_id')"
        :model="model"
        :errors="errors"
      />
      <div class="form-group">
        <button type="button" class="btn btn-primary" @click="submit">
          {{ $t("Save") }}
        </button>
        <button type="button" class="btn btn-light" @click="cancel">
          {{ $t("Cancel") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ResourceFormMixin from "../../../mixins/ResourceFormMixin.js";
import Proxy from "./Proxy.js";

export default {
  name: "OfferForm",

  mixins: [ResourceFormMixin],

  props: {
    company: { type: Object },
  },

  mounted() {
    if (this.company) {
      Proxy.company_id = this.company.id;
    }

    this.withUiBlocker(this.loadForm(Proxy), this.$el);
  },

  methods: {
    submit() {
      this.withUiBlocker(
        this.save(Proxy).then(() => {
          this.$toast.success(this.$t("Saved successfully"));
        }),
        this.$el
      );
    },
  },
};
</script>
